





















import Vue from "vue";
import SubmitButton from "@/components/basic/buttons/SubmitButton.vue";
import NavigationButton from "@/components/basic/buttons/NavigationButton.vue";
import { mapState } from "vuex";

export default Vue.extend({
  name: "UploadSucceeded",
  mounted() {
    this.saveInformationPath();
  },
  methods: {
    saveInformationPath(): void {
      window.localStorage.setItem(KeyWords.PATH, KeyWords.AUTOMATIC);
    },
  },
  data() {
    return {
      TRANSLATION_KEY: "steps.UploadSucceeded",
    };
  },
  components: {
    SubmitButton,
    NavigationButton,
  },
  computed: {
    ...mapState({
      isMobile: (state: any) => state.isDetectedMobileDevice,
    }),
  },
});

enum KeyWords {
  PATH = "path",
  AUTOMATIC = "automatic",
}
